import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys, gradient, palette } from "@clockwise/web-commons/src/styles/color.styles";

export const content: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  zIndex: 1,
  position: "relative",
  paddingBottom: 102, // offset for fixed schedule button
  minHeight: 300,
};

export const background: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  position: "absolute",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 0,
};

export const dashboard: CSSProperties = {
  paddingBottom: 20,
};

export const teammate: CSSProperties = {
  paddingTop: 20,
};

export const dropdownContainer: CSSProperties = {
  padding: "10px 0 0",
  display: "flex",
  alignItems: "center",
};

export const dropdown = {
  style: {
    height: 36,
    marginRight: "auto",
  } as CSSProperties,
  labelStyle: {
    height: 36,
    lineHeight: `36px`,
    paddingLeft: 0,
    fontSize: 14,
  } as CSSProperties,
  iconStyle: {
    height: 36,
    width: 36,
    padding: 0,
  } as CSSProperties,
  underlineStyle: {
    marginLeft: 0,
  } as CSSProperties,
};

export const addTeammatesBtn: CSSProperties = {
  marginTop: 15,
  border: `1px dashed ${greys.blueGrey}`,
  height: 48,
  disply: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  textAlign: "left",
};

export const copiedInviteLinkBtn: CSSProperties = {
  marginTop: 15,
  height: 48,
  display: "flex",
  alignItems: "center",
  textAlign: "center",
  background: gradient,
  color: palette.white,
  whiteSpace: "nowrap",
  textTransform: "none",
};

export const btnIcon: CSSProperties = {
  width: 40,
  marginRight: 16,
};
